module.exports = __webpack_public_path__ + "img/agro.96eeccae.svg";